var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5119 2.30323L1.1176 41.0885C0.71308 41.7889 0.500075 42.5835 0.5 43.3923C0.499925 44.2012 0.712783 44.9958 1.11717 45.6962C1.52157 46.3967 2.10324 46.9784 2.80371 47.3828C3.50419 47.7872 4.29879 48.0001 5.10762 48H49.8927C50.7015 48.0001 51.4961 47.7872 52.1966 47.3828C52.8971 46.9784 53.4787 46.3967 53.8831 45.6962C54.2875 44.9958 54.5004 44.2012 54.5003 43.3923C54.5002 42.5835 54.2872 41.7889 53.8827 41.0885L31.4908 2.30323C31.0864 1.60296 30.5049 1.02145 29.8046 0.617147C29.1043 0.212846 28.31 0 27.5013 0C26.6927 0 25.8984 0.212846 25.1981 0.617147C24.4978 1.02145 23.9163 1.60296 23.5119 2.30323Z",
    fill: "#EE404C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7938 14.2654H27.2096C25.7714 14.2654 24.6055 15.4313 24.6055 16.8696V29.3168C24.6055 30.755 25.7714 31.9209 27.2096 31.9209H27.7938C29.232 31.9209 30.3979 30.755 30.3979 29.3168V16.8696C30.3979 15.4313 29.232 14.2654 27.7938 14.2654Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5017 41.7928C29.1012 41.7928 30.3979 40.4961 30.3979 38.8966C30.3979 37.297 29.1012 36.0004 27.5017 36.0004C25.9021 36.0004 24.6055 37.297 24.6055 38.8966C24.6055 40.4961 25.9021 41.7928 27.5017 41.7928Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.95768bbd0dd12c1f5630868be2114ce0.svg";
export { ForwardRef as ReactComponent };